























import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    return {
      innerShow,
    };
  },
});
